import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { Observable, throwError } from 'rxjs';
import { ConvertStatus, UploadWithId } from '@innersight-os/shared/firestore-interfaces';
import { collectionGroup, doc, query, serverTimestamp, updateDoc, where } from 'firebase/firestore';
import { collectionData } from 'rxfire/firestore';
import { DocumentData } from '@firebase/firestore-types';

@Injectable({
  providedIn: 'root'
})
export class UploadsService {
  constructor(private db: Firestore) {}

  failTrue$ = (err: Error) => {alert(`${err} - Upload`); return throwError(()=>err)};

  getUploadsForOperation = (operationId: string): Observable<UploadWithId[]> =>
    collectionData(
      query<UploadWithId, DocumentData>(
        // eslint-able-next-line @typescript-eslint/no-explicit-any
        collectionGroup(this.db, 'uploads') as any,
        where('operationId', '==', operationId),
      ),
      {idField: 'id'},
    )

  resolveUploadConvertStatus = async (operationId: string, uploadId: string) => {
    const value: ConvertStatus = {
      never: {
        id: '0',
        timestamp: serverTimestamp(),
        message: "user resolved upload",
      }
    }
    try {
      await updateDoc(doc(this.db, `operations/${operationId}/uploads/${uploadId}`), "convert", value)
    } catch(err){
      console.error(`transaction failed - did not update upload field: convert`, err);
      throw err
    }
  }

}
